/* eslint-disable */
const findProperty = function (sellers, property) {
    let temp_property = "";
    sellers.forEach(seller => {
        seller.urls_properties.forEach(prop => {
            if (prop.property_id == property) {
                temp_property = prop.property_value;
            }
        })
    })
    return temp_property;
}

export function exractProductDomains(productDomains) {
    console.log('copy productDomains', structuredClone(productDomains));
    if (!productDomains || productDomains.length == 0) return [];
    let extracted = [];
    productDomains.forEach(domain => {
        domain.domain_urls.forEach(url => {
            extracted.push({
                domain_id: parseInt(domain.domain_id),
                domain_name: domain.domain_name,
                product_extract: domain.product_extract,
                product_id: parseInt(domain.product_id),
                url_id: parseInt(url.url_id),
                url: url.url,
                variation: url.variation,
                sellers: url.sellers,
                ean: findProperty(url.sellers, 7),
                sku: findProperty(url.sellers, 4),
                mpn: findProperty(url.sellers, 20),
                min_price: Math.min(...find_prices(url.sellers)),
                max_price: Math.max(...find_prices(url.sellers))
            })
        })
    });
    return extracted;
}

function find_prices(sellers, compare) {
    const prices = [];
    sellers.forEach(seller => {
        const price_property = seller.tracks_properties.find(p => p.property_id === 5)
        if (price_property !== undefined){
            const price = parseFloat(price_property.property_value)
            if(price >= 0) prices.push(price);
        }
    })
    return (!!prices.length) ? prices : [0];
}

export function compressToProductDomains(extracted) {
    let compressed = [];
    const all_domain_ids = extracted.map(x => x.domain_id);
    let unique_domain_ids = [...new Set(all_domain_ids)];
    unique_domain_ids.forEach(domain_id => {
        compressed.push({
            domain_id,
            domain_name: extracted.find(x => x.domain_id == domain_id).domain_name,
            product_extract: extracted.find(x => x.domain_id == domain_id).product_extract,
            product_id: extracted.find(x => x.domain_id == domain_id).product_id,
            product_urls: extracted.map(y => filterByDomainsReturnUrls(y, domain_id)).filter(f => !!f ),
        })
    })
    return compressed;
}

function filterByDomainsReturnUrls(item, domain_id) {
    if (item.domain_id === domain_id) {
        return {
            url_id: item.url_id,
            url: item.url,
            variation: item.variation,
            sellers: item.sellers,
        };
    }
    return false;
}

export function eliminate_negative_ids(productDomains) {
    let new_productDomains = JSON.parse(JSON.stringify(productDomains));
    new_productDomains.forEach(domain => {
        domain.domain_urls.forEach(url => {
            (url.url_id < 0) && (url.url_id = 0) // replace the negative id with 0 id
        })
    });
    return new_productDomains;
}

export function domains_clearance(productDomains) {
    console.log('domains_clearance')
    let new_productDomains = JSON.parse(JSON.stringify(productDomains));
    let domains_for_delete = [];
    console.log('new_productDomains - before', new_productDomains)
    new_productDomains.forEach(domain => {
        console.log('domain', domain)
        // domain.product_urls.forEach(u => {
        //     console.log('u.url_id', u.url_id)
        //     console.log('[...u.url].length', [...u.url].length)
        // })
        domain.product_urls = domain.product_urls.filter((u) => (!!u && [...u.url].length>0))
        if (!domain.product_urls.length) {
            domains_for_delete.push(domain.domain_id);
        }
    });
    console.log('domains_for_delete', domains_for_delete)
    new_productDomains = new_productDomains.filter(d => !domains_for_delete.includes(d.domain_id));
    console.log('exit clearance', new_productDomains)
    return new_productDomains;
}

export function myCapitallize(word) {
    const firstLetter = word.charAt(0).toUpperCase();
    const remainingLetters = word.slice(1);
    return firstLetter + remainingLetters;
}


// if(([field.627bac94b6f6f] * [x] * [price] * [qty] - [price]) > 1; ([field.627bac94b6f6f] * [x] * 39.7 * [qty] - [price]) ;[price])


// WEBPACK FOOTER //
// ./src/helpers/functions.js